//按钮权限类型枚举
export enum nodeTypeEnum {
    //公司
    corporation = 1,

    //系统
    system = 2,

    //部门
    department = 3,

    //菜单
    menu = 4,

    //按钮
    button = 5,

    //人员
    user=6,
}

/// <summary>
/// 按钮权限类型枚举
/// </summary>
export enum ButtonRoleTypeEnum {
    /// <summary>
    /// 菜单按钮
    /// </summary>
    MenuButton = 1,

    /// <summary>
    /// 数据按钮
    /// </summary>
    RowButton = 2,
}

/// <summary>
/// 数据规则类型
/// </summary>
export enum RuleTypeEnum {
    /// <summary>
    /// 菜单按钮
    /// </summary>
    DataRowRule = 1,

    /// <summary>
    /// 数据按钮
    /// </summary>
    DataButtonRule = 2,
}

/// <summary>
/// 按钮权限类型枚举
/// </summary>
export enum DataRuleConfigTypeEnum {
    /// <summary>
    /// 数据行规则配置
    /// </summary>
    DataRowRuleConfig = 1,

    /// <summary>
    /// 数据按钮规则配置
    /// </summary>
    DataButtonRuleConfig = 2,
}